(() => {
  const productId = '9083821490404';
  const messageId = 'invzi-tracking-card-shipping';
  let scheduled = false;
  const update = () => {
    scheduled = false;
    const cart = document.querySelector('#monster-cart-wrapper');
    if (!cart) return;
    const items = cart.querySelector('#mu-items-container');
    if (!items) return;
    const rows = [...items.querySelectorAll('.mu-cart-item[data-product-id]')];
    const onlyCards = rows.length > 0 && rows.every(row => row.dataset.productId === productId);
    cart.classList.toggle('invzi-tracking-card-only', onlyCards);
    let message = cart.querySelector('#' + messageId);
    if (onlyCards && !message) {
      message = document.createElement('p');
      message.id = messageId;
      message.textContent = 'Free standard shipping on Tracking Cards to the contiguous U.S. and Washington, DC. No minimum purchase. Other destinations: rates at checkout.';
      message.style.cssText = 'padding:14px 20px;margin:0;font-size:14px;line-height:1.5';
      items.before(message);
    } else if (!onlyCards && message) {
      message.remove();
    }
  };
  const observer = new MutationObserver(() => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  });
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['data-product-id']});
  update();
})();
